import * as API from '@/api'
import {getField, updateField} from 'vuex-map-fields';
//initial state
function initialState() {
    return {
        list: [],
        selected_company_id: null
    };
}
const state = initialState();

// actions

const actions = {


    async list(context,payload) {
        var response = await API.company.list(payload)
        // set company in list
        context.commit('set_list', {
            companies: response.companies.data
        });
        return response;
    },

    async switchSelectedCompanyId(context, payload) {
        var all_companies = context.getters.getCompanies
        var isCompanyExistInList = all_companies.some(company => {
            return company.id == payload.selected_company_id
        });
        if (isCompanyExistInList) {
            context.commit('set_selected', {
                selected_company_id: payload.selected_company_id
            });
        }
    }
};

//getters
const getters = {
    getField,

    getCompanies: (state, getters, rootState) => {
        return state.list;
    },
    /** get Selected company */
    getSelectedCompany: (state, getters) => {
        var selected_company_id = getters['getSelected'];
        return state.list.find(function (company) {
            return company.id == selected_company_id;
        });
    },

    userRoleInCompany: (state) => (company_id) =>{
        var company =  state.list.find(company => {
            return company.id == company_id;
        });
        return company.pivot.role;
    },

    getSelected: state => state.selected_company_id
}


// mutations
const mutations = {
    set_list(state,payload) {
        state.list = payload.companies
    },

    set_selected(state, payload, rootState) {
        state.selected_company_id = payload.selected_company_id
    },

    reset (state) {
        // acquire initial state
        const s = initialState ();
        Object.keys (s).forEach (key => {
            state[key] = s[key];
        });
    },
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
